// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@steiner/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { userListHeaderStyles } from "@steiner/Overrides/Widgets/UserList/UserListHeader";
import Search from "@steiner/XDL/Icons/Search";
import { getInputStyleWithIcon, mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

userListHeaderStyles.searchGridItem = {
    width: [12, 12, 8, 6, 6],
    css: css`
        ${xScreen("lte", "sm")} {
            order: 2;
            padding-top: 8px;
        }
    `,
};

userListHeaderStyles.buttonsGridItem = {
    width: [2, 2, 4, 3, 3],
    css: css`
        justify-content: flex-end;
        padding-top: 21px;
    `,
};

userListHeaderStyles.searchContainer = {
    css: css`
        padding-bottom: 10px;
    `,
};

userListHeaderStyles.userCountGridItem = {
    ...mergeWithCss(myAccountFilterSectionStyles.countGridItem, {
        css: css`
            ${xScreen("lte", "sm")} {
                order: 1;
                justify-content: start;
                padding-bottom: 0;
            }
        `,
    }),
    width: [12, 12, 4, 6, 6],
};

userListHeaderStyles.searchTextField = {
    ...mergeWithCss(getInputStyleWithIcon(Search), {
        cssOverrides: {
            formField: css`
                flex: 1 1 auto;
                margin-right: 16px;
            `,
        },
    }),
};

userListHeaderStyles.clearButton = {
    variant: "secondary",
    css: css`
        margin-right: 16px;
    `,
};

userListHeaderStyles.searchSubmitButton = {
    css: css`
        flex: 0 0 auto;
    `,
    variant: "primary",
};